<template>
  <div class="userSearch">
    <input
        class="search-box"
        placeholder="Username / Email"
        @keydown.enter="goToUser"
        type="text">
  </div>
</template>

<script>

export default {
  name: 'userSearch',
  methods: {
    goToUser (e) {
      let email = e.target.value.trim()

      if (email) {
        this.$router.push(
          {path: `/user/${email}`})
      }
    }
  }
}
</script>

<style scoped>

</style>
